import React from "react";
import { ReactSVG } from "react-svg";
import { convertMinutesToPixel } from "./Utils";
import moment from "moment";

const StepContent = ({
  stop,
  step,
  stepPopover,
  onClickStep,
  onHoverStep,
  handleCloseStepPopup,
  oneHourPx,
  isLate,
  breakEnd,
  breakStart,
  isHover,
  widthDuration,
  selectedMultipleSteps,
  setAllInclusiveMultipleSteps,
  multipleStepState,
  driverId,
  stepClicked,
}) => {
  const isMultipleSelected = multipleStepState?.steps?.find(
    item => item.orderId === step.orderId && item.type === step.type && driverId === item.driverId,
  );
  const isClicked = stepClicked?.type === step.type && stepClicked?.orderId === step.orderId;
  const style = {
    borderColor: step.color,
    color: step.color,
    borderWidth: isMultipleSelected || isClicked ? "3px" : "1px",
    width: typeof widthDuration === "number" && widthDuration < 10 ? 10 : widthDuration,

    // typeof widthDuration === "number" && widthDuration > 13
    // ? widthDuration - 8
    // : widthDuration < 10
    // ? 10
    // : widthDuration, TODO // Check bug
  };

  let widthWaitingMins = convertMinutesToPixel(step.waitingMins, oneHourPx);

  if (breakEnd && breakStart && step.waitingMins > 0) {
    const arrivalTime = moment(stop.arrivalTime, "HH:mm");
    const breakEndTime = moment(breakEnd, "HH:mm");
    const breakStartTime = moment(breakStart, "HH:mm");
    const startWaitingMins = arrivalTime.clone().subtract(step.waitingMins, "minutes");
    if (breakEndTime.isAfter(startWaitingMins) && breakStartTime.isBefore(startWaitingMins)) {
      const diffMins = breakEndTime.diff(startWaitingMins, "minutes");
      widthWaitingMins = convertMinutesToPixel(step.waitingMins - diffMins, oneHourPx);
    }
  }

  const styleWaitingMins = {
    top: "11px",
    position: "absolute",
    borderWidth: "1px",
    width: widthWaitingMins,
    left: -widthWaitingMins,
    borderStyle: "dashed",
    borderColor: "white",
    visibility: widthWaitingMins === 0 ? "hidden" : "",
  };

  const newClickStep = (e, step) => {
    if ((e.ctrlKey || e.metaKey) && selectedMultipleSteps) {
      selectedMultipleSteps && selectedMultipleSteps(step, driverId);
    } else if (e.shiftKey) {
      setAllInclusiveMultipleSteps && setAllInclusiveMultipleSteps(step, driverId);
    } else {
      onClickStep(step.orderId, step.type);
    }
  };

  if (
    (stop.status === "COMPLETED" && stop.type === "delivery") ||
    (["IN_TRANSIT", "DELIVERY_ARRIVED", "DELIVERY_FAILED", "COMPLETED"].includes(stop.status) && stop.type === "pickup")
  ) {
    style.color = "#fff";
    style.backgroundColor = step.color;
  }
  return (
    <>
      <div
        className={`${step.type.toLowerCase() === "pickup" ? "unit" : "unit unit2"} ${stepPopover} ${stop.status} ${
          isHover ? "hover" : ""
        }`}
        style={style}
        onClick={e => newClickStep(e, step)}
        onMouseOver={() => onHoverStep(step.orderId, step.type)}
        onMouseOut={() => handleCloseStepPopup()}>
        {step.index + 1}
      </div>
      {isLate && (
        <span className={`anticon isLate ${step.type.toLowerCase()}`}>
          <ReactSVG src={"/icons/late.svg"} />
        </span>
      )}
      <span className={"waitingMins"} style={styleWaitingMins}></span>
    </>
  );
};

export default StepContent;
